export { SkyTileComponent } from './tile.component';
export { SkyTileModule } from './tile.module';
